import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FcGlobe } from 'react-icons/fc';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const closeTimeoutRef = useRef<NodeJS.Timeout>();

  const changeLanguage = (lng: string) => {
    i18n?.changeLanguage?.(lng);
    setIsOpen(false);
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 250);
  };

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    setIsOpen(true);
  };

  const currentLanguage = i18n?.language || 'pt';

  return (
    <div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <button className="flex items-center text-gray-500 hover:text-gray-700">
        <FcGlobe className="h-5 w-5" />
        <span className="ml-1 text-sm uppercase">{currentLanguage}</span>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-24 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 z-10 animate-in fade-in duration-150">
          <button
            onClick={() => changeLanguage('pt')}
            className={`block w-full text-left px-4 py-2 text-sm ${currentLanguage === 'pt' ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-100'}`}
          >
            Português
          </button>
          <button
            onClick={() => changeLanguage('en')}
            className={`block w-full text-left px-4 py-2 text-sm ${currentLanguage === 'en' ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-100'}`}
          >
            English
          </button>
          <button
            onClick={() => changeLanguage('es')}
            className={`block w-full text-left px-4 py-2 text-sm ${currentLanguage === 'es' ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-100'}`}
          >
            Español
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
